// Modules
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MunicipalityCodeSetupGuard } from './internal/shared/municipality-code-setup.guard';
// Components
import { NoContent } from './no-content/no-content';
// Providers
import { ApiClientService } from './shared/api-client.service';
// Guards
import { AuthGuard } from './shared/auth.guard';
import { AuthService } from './shared/auth.service';
import { BillingSetupGuard } from './shared/billing-setup.guard';

const routes: Routes = [
  {
    path: 'external',
    loadChildren: () => import('./external/external.module').then(m => m.ExternalModule)
  },
  {
    path: '',
    loadChildren: () => import('./internal/internal.module').then(m => m.InternalModule),
    canActivate: [AuthGuard]
  },
  // Not found route
  { path: '**', component: NoContent }
];

// Guards and application wide providers
export const applicationRoutingProviders: any[] = [
  ApiClientService,
  AuthGuard,
  MunicipalityCodeSetupGuard,
  BillingSetupGuard,
  AuthService
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class ApplicationRoutingModule {}
